import React from 'react';
import HrSeperator from './HrSeperator';
import CopyToClipboard from 'react-copy-to-clipboard';


export function flatten(text, child) {
  if (typeof child === 'string') {
    return text + child;
  };
  return React.Children.toArray(child.props.children).reduce(flatten, text);
}

export function headingTextToSlug(text) {
  text = text.toLowerCase();
  // Remove markdown links, e.g. replace "[alt](url)"" with "alt".
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
  // Remove inline LaTeX.
  text = text.replace(/\$([^$]+)\$/g, '');
  // Remove words that contain LaTeX expressions.
  // Match math enclosed in the following patterns: $$...$$, $...$, \(...\), \[...\]
  // with optional whitespaces and after.
  text = text.replace(/(\$\$.*?\$\$|\$.*?\$|\\\(.*?\\\)|\\\[.*?\\\]\s*)/g, '');
  // Replace whitespaces with dashes.
  text = text.replace(/\W/g, '-');
  return '#' + text;
}

const hLevelToFontSize = {
  1: 'text-3xl mt-10',
  2: 'text-2xl mt-8',
  3: 'text-xl mt-5',
  4: 'text-lg mt-5',
  5: 'text-base mt-5',
  6: 'text-sm mt-5',
}

function HeadingRenderer( {children, level } ) {

  // // Do not render H1 headings
  // if ( level === 1 ) {
  //   return <></>
  // }

  var text = children.reduce(flatten, '');
  var slug = headingTextToSlug(text);  
  // level -= 1;

  const Component = `h${level}`;

  return (
  <div>
    <div className={`flex mb-3 ${hLevelToFontSize[level]} font-bold group`}>
      <Component id={slug} children={children}/>
      {/* <CopyToClipboard text={slug}> */}
        {/* <span className='ml-3 opacity-50 invisible group-hover:visible'>#</span> */}
      {/* </CopyToClipboard> */}
    </div>
    { level === 1 ? <HrSeperator/> : null }
  </div>
  );
}

export default HeadingRenderer;